// src/Routes/AppRoutes.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import NotFound from "../Error404";
import ProtectedRoute from "./ProtectedRoutes";
import Login from "../Pages/Auth/Login";
import Dashboard from "../Pages/Dashboard/Dashboard";
import GPPFT from "../Pages/WPPFT/WPPFT";
import GPFT from "../Pages/GPFT/GPFTAdmin";
import WPPFT from "../Pages/WPPFT/WPPFT";
import FacilitatorAsResourcePerson from "../Pages/Facilitator/FacilitatorAsResourcePerson";
import LineDepartmentDetails from "../Pages/Line/LineDepartmentDetails";
import LineDepartmentDetailsManage from "../Pages/Line/LineDepartmentDetailsManage";
import CommitteeMembersDetails from "../Pages/CommitteeMembersDetails/CommitteeMembersDetails";
import ScheduleMeeting from "../Pages/ScheduleMeeting/ScheduleMeeting";
import GPPFTs from "../Pages/GPPFTs/GPPFTs";
import ManageGPPFTs from "../Pages/GPPFTs/ManageGPPFTs";

import WPPFTAdmin from "../Pages/Admin/WPPFTAdmin";
import FrontlineWorkerOfficersAdmin from "../Pages/Admin/FrontlineWorkerOfficersAdmin";
import FacilitatorAsResourcePersonAdmin from "../Pages/Admin/FacilitatorAsResourcePersonAdmin";
import CommitteeMembersDetailsAdmin from "../Pages/Admin/CommitteeMembersDetailsAdmin";
import ViewMeetingForGramPanchayatAdmin from "../Pages/Admin/ViewMeetingForGramPanchayatAdmin";
import ViewMeetingForGramSabhaAdmin from "../Pages/Admin/ViewMeetingForGramSabhaAdmin";
import ViewMeetingForWardSabhaAdmin from "../Pages/Admin/ViewMeetingForWardSabhaAdmin";
import ViewMeetingForBalSabhaAdmin from "../Pages/Admin/ViewMeetingForBalSabhaAdmin";
import ViewMahilaSabhaMeetingAdmin from "../Pages/Admin/ViewMahilaSabhaMeetingAdmin";
import ScheduleMeetings from "../Pages/ScheduleMeetings/ScheduleMeetings";
import MahilaSabha from "../Pages/MahilaSabha/MahilaSabha";
import BalSabha from "../Pages/BalSabha/BalSabha";
import ManageWPPFT from "../Pages/WPPFT/ManageWPPFT";
import Profile from "../Pages/Profile/Profile";
import ViewScheduleMetting from "../Pages/ScheduleMeetings/ViewScheduleMetting";

import ManageFacilatorASResourcePerson from "../Pages/Facilitator/ManageFacilatorASResourcePerson";

import ManageCommitteMamberDetails from "../Pages/CommitteeMembersDetails/ManageCommitteMamberDetails";
import ManageMahilaSabha from "../Pages/MahilaSabha/ManageMahilaSabha";
import ManageBalSabha from "../Pages/BalSabha/ManageBalSabha";
import MeetingInvite from "../Pages/ScheduleMeetings/MeetingInvite";
import GramPanchayatMeeting from "../Pages/ScheduleMeetings/GramPanchayatMeeting";
import MahilaSabhaMetting from "../Pages/ScheduleMeetings/MahilaSabhaMetting";
import BalSabhameeting from "../Pages/ScheduleMeetings/BalSabhameeting";
import GramSabhaMeeting from "../Pages/ScheduleMeetings/GramSabhaMeeting";
import WardSabhaMOM from "../Pages/MOM/WardSabhaMOM";
import GramSabhaMOM from "../Pages/MOM/GramSabhaMOM";
import GramSabhaInspectionForms from "../Pages/Inspection/GramSabhaInspectionForms";
import DrinkingWaterForm from "../Pages/Inspection/DrinkingWaterForm";
import DrugAddictionForm from "../Pages/Inspection/DrugAddictionForm";
import CleanlinessForm from "../Pages/Inspection/CleanlinessForm";
import WastewaterForm from "../Pages/Inspection/WastewaterForm";
// src/Routes/AppRoutes.js
import BeneficiaryIncomeScreen from "../Pages/BeneficiaryIncomeScreen";

import GramPanchayatMOM from "../Pages/MOM/GramPanchayatMOM";
import MahilaSabhaMOM from "../Pages/MOM/MahilaSabhaMOM";
import BalSabhaMOM from "../Pages/MOM/BalSabhaMOM";
import ViewMeetingForGramPanchayat from "../Pages/ViewScheduleMeetingInLineDepartment/ViewMeetingForGramPanchayat";
import ViewMeetingForGramSabha from "../Pages/ViewScheduleMeetingInLineDepartment/ViewMeetingForGramSabha";
import ViewMeetingForWardSabha from "../Pages/ViewScheduleMeetingInLineDepartment/ViewMeetingForWardSabha";
import ViewMeetingForBalSabha from "../Pages/ViewScheduleMeetingInLineDepartment/ViewMeetingForBalSabha";
import ViewMahilaSabhaMeeting from "../Pages/ViewScheduleMeetingInLineDepartment/ViewMahilaSabhaMeeting";
import Logout from "../Logout";
import BDPOReport from "../Pages/BDPOReport";
import CEOZPReport from "../Pages/CEOZPReport";
import GramSabhaReport from "../Pages/GramSabhaReport";
import SchemeReport from "../Pages/SchemeReport";
import SchemeVerificationReportCEO from "../Pages/SchemeVerificationReportCEO";
import IncomeVerificationReportCEO from "../Pages/IncomeVerificationReportCEO";
import SpecialGramSabhaStatus from "../Pages/SpecialGramSabhaStatus";
import DevelopmentWork from "../Pages/DevelopmentWork";
import AmritSarovar from "../Pages/AmritSarovar";
import GramSabhaBDPOReport from "../Pages/ReportBDPO";
import GramSabhaCEOReport from "../Pages/ReportCEO";
import ReportAdmin from "../Pages/ReportAdmin";
import DistrictAdminReport from "../Pages/DistrictAdminReport";
import DistrictCEOReport from "../Pages/DistrictCEOReport";
import DistrictBDPOReport from "../Pages/DistrictBDPOReport";
import DistrictwiseSpecialGSComplianceCEO from "../Pages/DistrictwiseSpecialGSComplianceCEO";
import DistrictwiseSpecialGSComplianceAdmin from "../Pages/DistrictwiseSpecialGSCompilanceAdmin";
import DistrictwiseSpecialGSComplianceBDPO from "../Pages/DistrictwiseSpecialGSCompilanceBDPO";
import WidowPension from "../Pages/WidowPension";
import DisabilityPension from "../Pages/DisabilityPension";
import OldAgeSamanAllowance from "../Pages/OldAgeSamanAllowance";
import DeenDayalLaadoYojna from "../Pages/DeenDayalLaadoYojna";
import GramSachivReport from "../Pages/ReportSachiv.jsx";
import DistrictSachivReport from "../Pages/DistrictSachivReport.jsx";
import DistrictwiseSpecialGSComplianceSachiv from "../Pages/DistrictWiseSpecialGSCompilanceSachiv.jsx";

import MeetingApprovalPage from "../Pages/ScheduleMeetings/MeetingApprovalPage";
import GeneralGramSabhaStatusAdmin from "../Pages/GeneralGramSabhaStatusAdmin";

const AppRoutes = () => {
  const PrivateRoutesData = [

    {
      path: "/dashboard",
      component: Dashboard,
      allowedRoles: [1, 2],
    },
    {
      path: "/wppft",
      component: WPPFT,
      allowedRoles: [2],
    },
    {
      path: "/manage-wppft",
      component: ManageWPPFT,
      allowedRoles: [2],
    },
    {
      path: "/gppfts",
      component: GPPFTs,
      allowedRoles: [2],
    },
    {
      path: "/managegppft",
      component: ManageGPPFTs,
      allowedRoles: [2],
    },
    {
      path: "/facilator-as-resource-person",
      component: FacilitatorAsResourcePerson,
      allowedRoles: [2],
    },

    {
      path: "/ManageFacilatorASResourcePerson",
      component: ManageFacilatorASResourcePerson,
      allowedRoles: [2],
    },
    {
      path: "/committee-members-details",
      component: CommitteeMembersDetails,
      allowedRoles: [2],
    },
    {
      path: "/ManageCommitteMamberDetails",
      component: ManageCommitteMamberDetails,
      allowedRoles: [2],
    },
    {
      path: "/ward-sabha-meeting",
      component: ScheduleMeetings,
      allowedRoles: [2],
    },
    {
      path: "/gram-panchayat-meeting",
      component: GramPanchayatMeeting,
      allowedRoles: [2],
    },
    {
      path: "/mahila-sabha-meeting",
      component: MahilaSabhaMetting,
      allowedRoles: [2],
    },
    {
      path: "/bal-sabha-meeting",
      component: BalSabhameeting,
      allowedRoles: [2],
    },
    {
      path: "/gram-sabha-meeting",
      component: GramSabhaMeeting,
      allowedRoles: [2],
    },
    {
      path: "/MeetingInvite",
      component: MeetingInvite,
      allowedRoles: [2],
    },
    {
      path: "/ward-sabha-meeting",
      component: ScheduleMeetings,
      allowedRoles: [2],
    },

    {
      path: "/view-schedule-meetings",
      component: ViewScheduleMetting,
      allowedRoles: [2],
    },
    {
      path: "/mahilasabha",
      component: MahilaSabha,
      allowedRoles: [2],
    },
    {
      path: "/ManageMahilaSabha",
      component: ManageMahilaSabha,
      allowedRoles: [2],
    },
    {
      path: "/balsabha",
      component: BalSabha,
      allowedRoles: [2],
    },
    {
      path: "/ManageBalSabha",
      component: ManageBalSabha,
      allowedRoles: [2],
    },
    {
      path: "/gram-sachiv-report",
      component: GramSachivReport,
      allowedRoles: [2],
    },
    {
      path: "/district-sachiv-report",
      component: DistrictSachivReport,
      allowedRoles: [2],
    },
    {
      path: "/districtwise-gs-compliance-sachiv",
      component: DistrictwiseSpecialGSComplianceSachiv,
      allowedRoles: [2],
    },
    // {
    //   path: "/meeting-approval-list",
    //   component: MeetingApprovalList,
    //   allowedRoles: [2],
    // },
    {
      path: "/meeting-approval/:meetingId",
      component: MeetingApprovalPage,
      allowedRoles: [2],
    },
    {
      path: "/gram-panchayat-planning",
      component: GPFT,
      allowedRoles: [1, 2],
    },
    {
      path: "/line-department-details",
      component: LineDepartmentDetails,
      allowedRoles: [2, 3, 4],
    },
    {
      path: "/line-department-details-manage",
      component: LineDepartmentDetailsManage,
      allowedRoles: [2],
    },
    {
      path: "/ward-panchayat-planning",
      component: WPPFTAdmin,
      allowedRoles: [1],
    },
    {
      path: "/gram-sabha-report",
      component: GramSabhaReport,
      allowedRoles: [1], // change roles as per your requirement
    },
    {
      path: "/scheme-report",
      component: SchemeReport,
      allowedRoles: [1, 5, 6], // change roles as per your requirement
    },
    {
      path: "/scheme-verification-ceo",
      component: SchemeVerificationReportCEO,
      allowedRoles: [8, 7, 2],
    },
    {
      path: "/income-verification-ceo",
      component: IncomeVerificationReportCEO,
      allowedRoles: [8, 7, 2],
    },


    {
      path: "/special-gram-sabha-status",
      component: SpecialGramSabhaStatus,
      allowedRoles: [1, 2, 3, 5, 6, 7, 8],
    },

    {
      path: "/FacilitatorAsResourceAdmin",
      component: FacilitatorAsResourcePersonAdmin,
      allowedRoles: [1],
    },
    {
      path: "/FrontlineWorkerOfficersAdmin",
      component: FrontlineWorkerOfficersAdmin,
      allowedRoles: [1],
    },
    {
      path: "/CommitteeMembersDetailsAdmin",
      component: CommitteeMembersDetailsAdmin,
      allowedRoles: [1],
    },
    {
      path: "/ViewMeetingForGramPanchayatAdmin",
      component: ViewMeetingForGramPanchayatAdmin,
      allowedRoles: [1],
    },
    {
      path: "/ViewMeetingForGramSabhaAdmin",
      component: ViewMeetingForGramSabhaAdmin,
      allowedRoles: [1],
    },
    {
      path: "/View-Meeting-For-Ward-Sabha-Admin",
      component: ViewMeetingForWardSabhaAdmin,
      allowedRoles: [1],
    },
    {
      path: "/view-meeting-for-bal-sabha-admin",
      component: ViewMeetingForBalSabhaAdmin,
      allowedRoles: [1],
    },
    {
      path: "/view-mahila-sabha-meeting-admin",
      component: ViewMahilaSabhaMeetingAdmin,
      allowedRoles: [1],
    },

    {
      path: "/districtwise-gs-compliance-admin",
      component: DistrictwiseSpecialGSComplianceAdmin,
      allowedRoles: [1], // 🔥 ADMIN ONLY
    },
    {
      path: "/Profile",
      component: Profile,
      allowedRoles: [1, 2],
    },
    {
      path: "/ward-sabha-mom",
      component: WardSabhaMOM,
      allowedRoles: [1, 2],
    },
    {
      path: "/gram-sabha-mom",
      component: GramSabhaMOM,
      allowedRoles: [1, 2],
    },
    {
      path: "/gram-sabha-inspection",
      component: GramSabhaInspectionForms,
      allowedRoles: [1, 2, 3, 7, 8],
    },
    {
      path: "/gram-sabha-inspection/drinking-water/:meetingId",
      component: DrinkingWaterForm,
      allowedRoles: [2],
    },
    {
      path: "/gram-sabha-inspection/drug-addiction/:meetingId",
      component: DrugAddictionForm,
      allowedRoles: [2],
    },
    {
      path: "/gram-sabha-inspection/cleanliness/:meetingId",
      component: CleanlinessForm,
      allowedRoles: [2],
    },
    {
      path: "/gram-sabha-inspection/wastewater/:meetingId",
      component: WastewaterForm,
      allowedRoles: [2],
    },
    {
      path: "/beneficiary-screen",
      component: BeneficiaryIncomeScreen,
      allowedRoles: [1, 2],
    },
    {
      path: "/development-work",
      component: DevelopmentWork,
      allowedRoles: [1, 2], // adjust roles as per requirement
    },
    {
      path: "/amrit-sarovar",
      component: AmritSarovar,
      allowedRoles: [1, 2],
    },
    {
      path: "/gram-panchayat-mom",
      component: GramPanchayatMOM,
      allowedRoles: [1, 2],
    },
    {
      path: "/mahila-sabha-mom",
      component: MahilaSabhaMOM,
      allowedRoles: [1, 2],
    },
    {
      path: "/bal-sabha-mom",
      component: BalSabhaMOM,
      allowedRoles: [1, 2],
    },

    // Gs Logins
    {
      path: "/view-gram-panchayat-meeting",
      component: ViewMeetingForGramPanchayat,
      allowedRoles: [3],
    },
    {
      path: "/view-gram-sabha-meeting",
      component: ViewMeetingForGramSabha,
      allowedRoles: [3],
    },
    {
      path: "/view-ward-sabha-meeting",
      component: ViewMeetingForWardSabha,
      allowedRoles: [3],
    },
    {
      path: "/view-bal-sabha-meeting",
      component: ViewMeetingForBalSabha,
      allowedRoles: [3],
    },
    {
      path: "/view-mahila-sabha-meeting",
      component: ViewMahilaSabhaMeeting,
      allowedRoles: [3],
    },
    {
      path: "/bdpo-report",
      component: BDPOReport,
      allowedRoles: [7],
    },
    {
      path: "/ceozp-report",
      component: CEOZPReport,
      allowedRoles: [8],
    },
    {
      path: "/gram-sabha-report-ceo",
      component: GramSabhaCEOReport,
      allowedRoles: [8],
    },
    {
      path: "/district-ceo-report",
      component: DistrictCEOReport,
      allowedRoles: [8],   // 🔥 CEO ONLY
    },
    {
      path: "/districtwise-gs-compliance-ceo",
      component: DistrictwiseSpecialGSComplianceCEO,
      allowedRoles: [8],
    },

    {
      path: "/gram-sabha-report-bdpo",
      component: GramSabhaBDPOReport,
      allowedRoles: [7],
    },
    {
      path: "/districtwise-gs-compliance-bdpo",
      component: DistrictwiseSpecialGSComplianceBDPO,
      allowedRoles: [7], // 🔥 BDPO ONLY
    },
    {
      path: "/district-bdpo-report",
      component: DistrictBDPOReport,
      allowedRoles: [7],   // BDPO ONLY
    },

    {
      path: "/admin-report",
      component: ReportAdmin,
      allowedRoles: [1],
    },
    {
      path: "/district-admin-report",
      component: DistrictAdminReport,
      allowedRoles: [1],
    },
    {
      path: "/general-gram-sabha-status-admin",
      component: GeneralGramSabhaStatusAdmin,
      allowedRoles: [1, 2, 3, 7, 8],
    },

    {
      path: "/ceozp-report",
      component: CEOZPReport,
      allowedRoles: [5, 6],
    },

    {
      path: "/widow-pension",
      component: WidowPension,
      allowedRoles: [5, 6],
    },
    {
      path: "/disability-pension",
      component: DisabilityPension,
      allowedRoles: [5, 6],
    },
    {
      path: "/old-age-saman-allowance",
      component: OldAgeSamanAllowance,
      allowedRoles: [5, 6],
    },
    {
      path: "/deen-dayal-laado-lakshmi-yojna",
      component: DeenDayalLaadoYojna,
      allowedRoles: [5, 6],
    },
    {
      path: "/logout",
      component: Logout,
      allowedRoles: [1, 2, 3, 4, 5, 6, 7, 8],
    },
  ];

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        {PrivateRoutesData.map((data) => (
          <Route
            key={data.path}
            path={data.path}
            element={
              <ProtectedRoute
                component={data.component}
                allowedRoles={data.allowedRoles}
              />
            }
          />
        ))}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
